"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("./styles/_error.scss");

function reloadPage() {
  window.location.reload();
}

var HELP_URL = "https://intercom.help/shootstahub/en",
    openHelpPage = function openHelpPage() {
  window.open(HELP_URL, "_blank");
};

function Error(_ref) {
  var onSubmitError = _ref.onSubmitError;
  return _react["default"].createElement("div", {
    className: "error-page"
  }, _react["default"].createElement("div", {
    className: "error-page__inner"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "error-page__icon",
    name: "robot"
  }), _react["default"].createElement("p", {
    className: "error-page__header"
  }, "Hmm.. that wasn't supposed to happen."), _react["default"].createElement("p", {
    className: "error-page__suggest"
  }, "Try reloading the page and try again.."), _react["default"].createElement("div", {
    className: "error-page__buttons"
  }, _react["default"].createElement(_uiKit.Button, {
    onClick: reloadPage,
    type: "SECONDARY"
  }, "Reload Page"), onSubmitError ? _react["default"].createElement(_uiKit.Button, {
    onClick: onSubmitError
  }, "Submit Error Report") : null)), _react["default"].createElement("p", {
    className: "error-page__assist"
  }, "If the problem persists, contact your dedicated Account Manager or visit our", " ", _react["default"].createElement("strong", null, _react["default"].createElement(_uiKit.LinkButton, {
    onClick: openHelpPage
  }, "Help Center")), " ", "for more information."));
}

var _default = (0, _react.memo)(Error);

exports["default"] = _default;